import React from "react";

const svgPaths = {
  p128a9e00:
    "M20.189 84.2464C33.8199 85.5985 47.4945 77.2722 57.5452 68.8857C64.3826 63.1815 69.6488 55.8241 72.7801 47.4869C74.7179 42.3246 76.1084 36.9763 76.7982 31.5732C82.7487 -14.9852 49.4926 -6.23188 38.4675 32.9746C27.4424 72.1812 11.2934 76.254 4.3356 54.68C2.59479 49.2879 1.16054 45.6475 0 43.3976C0.591218 60.8878 4.51077 82.6917 20.1835 84.2519L20.189 84.2464Z",
  p354afc00:
    "M87.7695 175.539C39.2958 175.539 -2.11886e-06 136.244 0 87.7698C2.11886e-06 39.296 39.2958 0.000238869 87.7695 0.000240988C136.243 0.000243107 175.539 39.296 175.539 87.7698C175.539 136.244 136.243 175.539 87.7695 175.539ZM87.7695 13.7261C46.8763 13.7261 13.7259 46.8766 13.7259 87.7698C13.7259 128.663 46.8763 161.813 87.7695 161.813C128.663 161.813 161.813 128.663 161.813 87.7698C161.813 46.8766 128.663 13.7261 87.7695 13.7261Z",
  p3faf4b00:
    "M172.549 87.7696C174.201 87.7696 175.545 86.4301 175.488 84.7796C174.844 65.8644 168.099 47.6332 156.219 32.8315C143.714 17.2513 126.268 6.40336 106.764 2.07998C87.2595 -2.24339 66.8637 0.216559 48.9466 9.05338C31.0294 17.8902 16.6631 32.5751 8.22125 50.6817C-0.220592 68.7883 -2.23275 89.2331 2.51724 108.638C7.26723 128.043 18.4951 145.247 34.3458 157.407C50.1964 169.567 69.7212 175.956 89.6943 175.518C108.669 175.102 126.97 168.548 141.873 156.881C143.173 155.863 143.335 153.972 142.273 152.707V152.707C141.212 151.443 139.328 151.283 138.026 152.297C124.168 163.091 107.177 169.153 89.5631 169.539C70.951 169.947 52.7565 163.994 37.9859 152.662C23.2153 141.33 12.7524 125.299 8.3261 107.216C3.89976 89.1333 5.77481 70.0816 13.6415 53.2087C21.5081 36.3359 34.8956 22.6516 51.5919 14.4169C68.2882 6.18216 87.2943 3.88983 105.47 7.91862C123.645 11.9474 139.902 22.0562 151.555 36.5749C162.583 50.3149 168.863 67.2262 169.504 84.7798C169.565 86.4301 170.898 87.7696 172.549 87.7696V87.7696Z",
  p5e99d80:
    "M32.4532 0.123834C24.7352 -1.02983 16.9924 6.07433 11.3015 13.2299C7.43015 18.0968 4.44834 24.3742 2.67537 31.4877C1.57812 35.8922 0.790817 40.4555 0.400268 45.0655C-2.96899 84.79 15.861 77.3215 22.1036 43.8698C28.3462 10.4181 37.49 6.94309 41.4296 25.3504C42.4153 29.9511 43.2274 33.0571 43.8845 34.9768C43.5497 20.0538 41.3304 1.45032 32.4563 0.119163L32.4532 0.123834Z",
  p6a9b500:
    "M4.10544 74.2833C16.8604 120.688 74.8162 78.1317 80.7667 31.5732C86.7172 -14.9852 53.4612 -6.23188 42.4361 32.9746C31.411 72.1812 15.2619 76.254 8.30418 54.68C-2.24469 21.9659 -1.68631 53.2239 4.10544 74.2833Z",
  pd23c100:
    "M43.8564 17.1111C36.6262 -22.5034 3.77378 13.8258 0.40072 53.5712C-2.97234 93.3165 15.8789 85.8441 22.1286 52.3748C28.3782 18.9056 37.5323 15.4287 41.4764 33.8457C47.456 61.7726 47.1395 35.0888 43.8564 17.1111Z",
};

type AnimatedLoaderProps = {
  className?: string;
};

function Group1() {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div
        className="-translate-y-1/6 relative h-1/2 w-1/4 -translate-x-1/3 animate-pulse"
        style={
          {
            "--transform-inner-width": "1200",
            "--transform-inner-height": "19",
          } as React.CSSProperties
        }
      >
        <div className="h-full w-full rotate-[-6.41deg] skew-x-[-1.4deg]">
          <div className="relative h-full w-full" data-name="Vector">
            <svg
              className="absolute block size-full"
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 46.1836 80.5242"
            >
              <path d={svgPaths.pd23c100} fill="url(#paint0_linear_1_8958)" id="Vector" />
              <defs>
                <linearGradient
                  gradientUnits="userSpaceOnUse"
                  id="paint0_linear_1_8958"
                  x1="61.8512"
                  x2="-10.4051"
                  y1="8.61653"
                  y2="19.3354"
                >
                  <stop stopColor="#00EC97" />
                  <stop offset="1" stopColor="#0FCF8A" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div
        className="-translate-y-1/12 absolute h-2/5 w-1/5 -translate-x-1/4 animate-pulse mix-blend-soft-light"
        style={
          {
            "--transform-inner-width": "1200",
            "--transform-inner-height": "19",
            animationDelay: "0.2s",
          } as React.CSSProperties
        }
      >
        <div className="h-full w-full rotate-[-6.42deg] skew-x-[-1.41deg]">
          <div className="relative h-full w-full" data-name="Vector">
            <svg
              className="absolute block size-full"
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 43.8845 72.0044"
            >
              <g id="Vector" style={{ mixBlendMode: "soft-light" }}>
                <path d={svgPaths.p5e99d80} fill="url(#paint0_linear_1_8956)" />
              </g>
              <defs>
                <linearGradient
                  gradientUnits="userSpaceOnUse"
                  id="paint0_linear_1_8956"
                  x1="58.7721"
                  x2="-9.69662"
                  y1="7.70486"
                  y2="18.4982"
                >
                  <stop stopColor="#00EC97" />
                  <stop offset="1" stopColor="#0FCF8A" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

function Group2() {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div
        className="-translate-y-1/6 absolute h-1/2 w-1/3 translate-x-1/4 animate-pulse"
        data-name="Vector"
        style={{ animationDelay: "0.4s" } as React.CSSProperties}
      >
        <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 81.4737 94.3275">
          <path d={svgPaths.p6a9b500} fill="url(#paint0_linear_1_8950)" id="Vector" />
          <defs>
            <linearGradient
              gradientUnits="userSpaceOnUse"
              id="paint0_linear_1_8950"
              x1="109.113"
              x2="-14.9683"
              y1="10.0936"
              y2="37.8138"
            >
              <stop stopColor="#00EC97" />
              <stop offset="1" stopColor="#0FCF8A" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div
        className="-translate-y-1/12 absolute h-2/5 w-1/4 translate-x-1/3 animate-pulse mix-blend-soft-light"
        data-name="Vector"
        style={{ animationDelay: "0.6s" } as React.CSSProperties}
      >
        <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 77.5051 84.3915">
          <g id="Vector" style={{ mixBlendMode: "soft-light" }}>
            <path d={svgPaths.p128a9e00} fill="url(#paint0_linear_1_8940)" />
          </g>
          <defs>
            <linearGradient
              gradientUnits="userSpaceOnUse"
              id="paint0_linear_1_8940"
              x1="103.798"
              x2="-13.5109"
              y1="9.03036"
              y2="36.8964"
            >
              <stop stopColor="#00EC97" />
              <stop offset="1" stopColor="#0FCF8A" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  );
}

function Group3() {
  return (
    <div className="absolute inset-0 animate-spin" style={{ animationDuration: "3s" } as React.CSSProperties}>
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 175.539 175.539">
        <g id="Group 1000005055">
          <path d={svgPaths.p354afc00} fill="url(#paint0_linear_1_8952)" fillOpacity="0.5" id="Ellipse 1256" />
          <path d={svgPaths.p3faf4b00} fill="url(#paint1_linear_1_8952)" id="Ellipse 1257" />
        </g>
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint0_linear_1_8952"
            x1="175.539"
            x2="60.0836"
            y1="87.7698"
            y2="60.0856"
          >
            <stop stopColor="#00EC97" />
            <stop offset="1" stopColor="#008656" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint1_linear_1_8952"
            x1="87.7698"
            x2="60.0857"
            y1="9.76199e-05"
            y2="115.456"
          >
            <stop stopColor="#00EC97" />
            <stop offset="1" stopColor="#008656" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export default function AnimatedLoader({ className }: AnimatedLoaderProps) {
  return (
    <div
      className={`relative flex items-center justify-center overflow-hidden rounded-[10px] bg-[#0c0c0c] ${className ?? ""}`}
      data-name="Loader"
    >
      <div className="relative aspect-square w-[200px]">
        <Group3 />
        <Group1 />
        <Group2 />
      </div>
    </div>
  );
}
